/** * This file pulls the URL from the environment.
 * In production, you just change the .env file, not the code.
 */
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const CA_API = process.env.REACT_APP_SHORT_VET_CARD_CA_API || 'http://localhost:3001/api/ca-generate';
export const API_KEY = process.env.REACT_APP_SHORT_VET_CARD_API_KEY || 'http://localhost:3001/api/ca-generate';
